export default __webpack_public_path__ + "static/media/graduation.bf348954.svg";